import React, { useEffect, useState } from 'react'
import './ConfirmAdult.css'

interface ConfirmAdultData {
  isConfirm: boolean
  expired: number
}

function ConfirmAdultModal() {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const checkAdultConfirmation = () => {
      if (typeof window === 'undefined') return

      try {
        const currentDate = new Date()
        const confirmAdultStr = localStorage.getItem('CONFIRM_ADULT')
        const confirmAdultObj: ConfirmAdultData = confirmAdultStr
          ? JSON.parse(confirmAdultStr)
          : { isConfirm: false, expired: 0 }

        if (
          confirmAdultObj.isConfirm &&
          confirmAdultObj.expired >= currentDate.getTime()
        ) {
          setIsVisible(false)
        }
      } catch (error) {
        console.error('Error checking adult confirmation:', error)
      }
    }

    checkAdultConfirmation()
  }, [])

  // 確認ボタン押下時の処理
  const handleConfirmAdult = () => {
    try {
      const d = new Date()
      d.setDate(d.getDate() + 1)
      const confirmData: ConfirmAdultData = {
        isConfirm: true,
        expired: d.getTime(),
      }
      localStorage.setItem('CONFIRM_ADULT', JSON.stringify(confirmData))
      setIsVisible(false)
    } catch (error) {
      console.error('Error saving adult confirmation:', error)
    }
  }

  if (!isVisible) return null

  return (
    <div id="confirmAdult">
      <div className="confirmAdult-content">
        <h1 className="title">年齢確認</h1>
        <h2 className="sub-title">あなたは18歳以上ですか？</h2>
        <span className="text-content">
          この先はアダルトコンテンツを扱う
          <br />
          アダルトサイトになります
        </span>
        <span className="text-content-pc">
          この先はアダルトコンテンツを扱うアダルトサイトになります
        </span>
        <br />
        18歳未満の方のアクセスは固くお断りします
        <div className="confirmAdult-action">
          <button className="confirm" onClick={handleConfirmAdult}>
            はい
          </button>
          <br />
          <a href="https://www.yahoo.co.jp/">いいえ</a>
        </div>
      </div>
    </div>
  )
}

export default ConfirmAdultModal
